// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.Setting_settings__HTr7K {display: flex; flex-wrap: wrap; width:100%;}
.Setting_settings__HTr7K > div:nth-child(2n-1){width: 550px;}
.Setting_settings__HTr7K > div:nth-child(2n){width: calc(100% - 610px);}
.Setting_settings__HTr7K .Setting_container__qQa36{
    background: #fff;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.10);
    box-sizing: border-box;
}

.Setting_settings__HTr7K .Setting_container__qQa36#Setting_first__XjWsb {
    flex:1 1;
}

.Setting_settings__HTr7K > .Setting_container__qQa36:last-child  {
    margin-bottom:20px;
}

.Setting_settings__HTr7K > div:nth-child(2) .Setting_container__qQa36:nth-child(2) {
    margin-top: 20px;
}

.Setting_settings__HTr7K > div .Setting_top__ad0Sk{display: flex;align-items: center; margin-bottom: 10px;}
.Setting_settings__HTr7K > div .Setting_top__ad0Sk .Setting_more__OBn7y{ margin-left: auto; text-decoration: underline; font-weight:700; }
.Setting_settings__HTr7K > div .Setting_top__ad0Sk .Setting_more__OBn7y .Setting_on__pnNQV{ margin-left: auto; text-decoration: underline; font-weight:700; color:#51D7DF;}
.Setting_settings__HTr7K > div .Setting_top__ad0Sk .Setting_tit__bzvYY{
    font-size: 18px;
    font-weight: 700;
}



/*병원정보*/
.Setting_h_info__rA0zx .Setting_basic__Rpr0x{display: flex;}
.Setting_h_info__rA0zx svg{position: relative; top: 2px; margin-right:5px;}
.Setting_h_info__rA0zx .Setting_label__P51JP{font-weight: 600; font-size:14px; color:#9D9D9D;}
.Setting_h_info__rA0zx .Setting_basic__Rpr0x .Setting_profile__68kX\\+ {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right:15px;
}

.Setting_h_info__rA0zx .Setting_basic__Rpr0x .Setting_profile__68kX\\+ img {
    width: 138px;
    height: 138px;
    border-radius: 15px;
    margin: 0 22px;
    margin-bottom: 10px;
}

.Setting_h_info__rA0zx .Setting_basic__Rpr0x .Setting_profile__68kX\\+ .Setting_profileBtn__Al5ut {
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.Setting_h_info__rA0zx .Setting_basic__Rpr0x .Setting_profile__68kX\\+ button {
    width: 80px;
    height: 30px;
    background: #51D7DF;
    color: #FFFFFF;
    border-radius: 5px;
    border: none;
    margin: 0px 5px;
}

.Setting_h_info__rA0zx .Setting_basic__Rpr0x .Setting_profile__68kX\\+ input[type="file"] { display: none; }

.Setting_basic_con__gLTu1 .Setting_data__W5Wi6 {
    font-size:18px;
    font-weight: 700;
}
.Setting_basic_con__gLTu1 .Setting_tag_con__k12Bd {
    flex-wrap: wrap;
    width: 320px;
    height: 65px;
    overflow-y: scroll;
    display:flex;
    flex-direction: row;
}

.Setting_basic_con__gLTu1 > div { margin-bottom: 12px; }
.Setting_basic_con__gLTu1 > div:last-child { margin-bottom: 0; }
.Setting_basic_con__gLTu1 > div span { display: block; margin-bottom:5px;}

.Setting_basic_input__cbNeN {
    background-color: white; 
    border: 1px solid #ccc; 
    border-radius: 5px; 
    padding: 5px 10px; 
    margin: 5px 0; 
    width: calc(100% - 20px); 
}

.Setting_basic_textarea__50FQC {
    background-color: white;
    border: 1px solid #ccc; 
    border-radius: 5px; 
    padding: 5px 10px; 
    margin: 5px 0; 
    width: calc(100% - 20px); 
    resize: none;
    font-size:14px;
    height: 60px;
}

.Setting_h_info__rA0zx .Setting_intro__SV20G, .Setting_h_info__rA0zx .Setting_time__rbxaq{margin-top: 20px; height:80px;}
.Setting_h_info__rA0zx .Setting_info_con__GZqzE{height: 80px; margin-bottom: 10px;}

/* 후기확인 */
.Setting_show_review__z0ZeC .Setting_rv_password__uAXOm {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap:10px;
}

.Setting_show_review__z0ZeC .Setting_rv_password__uAXOm > p {
    display: flex;
    width:120px;
    height:30px;
    align-items: center; 
    color: #8B8686;
}

.Setting_show_review__z0ZeC .Setting_rv_password__uAXOm input {
    width: auto;
    height: 30px;
    border: 1px solid #ccc;
    font-size:14px;
    border-radius: 5px;
    padding: 5px 10px;
    margin: 5px 0;
}

.Setting_show_review__z0ZeC .Setting_rv_password__uAXOm button {
    width: 100px;
    height: 30px;
    background: #51D7DF;
    color: #FFFFFF;
    border-radius: 5px;
    border: none;
}



/* 예약 연동 */
.Setting_rsv_conn__XxCSZ .Setting_channel__atLS7 {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    gap:10px;
}

.Setting_channel__atLS7 .Setting_tit__bzvYY {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap:3px; 
}

.Setting_channel__atLS7 .Setting_tit__bzvYY > img {
    width:18px;
    height:18px;
}

.Setting_channel__atLS7 .Setting_tit__bzvYY > p {
    display: flex;
    width:90px;
    height:30px;
    align-items: center; 
    color: #000;
    font-weight: 400;
}

.Setting_channel__atLS7 input[type="text"] {
    width: auto;
    height: 30px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px 10px;
}
.Setting_channel__atLS7 .Setting_toggle__vX\\+mt {
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap:10px;
    width: 120px;
    height: 50px;
    font-size: 14px;
}
.Setting_toggle__vX\\+mt p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.Setting_toggle__vX\\+mt .Setting_use__VK-WY {
    color:#34C759;
}

.Setting_toggle__vX\\+mt .Setting_notuse__LhN1r {
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Setting/index.module.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,0BAAqD,aAAa,EAAuB,eAAe,EAAE,UAAU,CAAC;AACrH,+CAAgC,YAAY,CAAC;AAC7C,6CAA8B,yBAAyB,CAAC;AACxD;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEX,gDAAgD;IAEhD,sBAAsB;AAClC;;AAEA;IACI,QAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mDAA+D,aAAa,CAAkD,mBAAmB,EAAE,mBAAmB,CAAC;AACvK,yEAA4B,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AAC5F,4FAAgC,iBAAiB,EAAE,0BAA0B,EAAE,eAAe,EAAE,aAAa,CAAC;AAC9G;IACI,eAAe;IACf,gBAAgB;AACpB;;;;AAIA,OAAO;AACP,6CAAyD,aAAa,CAAC;AACvE,2BAAY,kBAAkB,EAAE,QAAQ,EAAE,gBAAgB,CAAC;AAC3D,6CAAe,gBAAgB,EAAE,cAAc,EAAE,aAAa,CAAC;AAC/D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA,2FAA6C,aAAa,EAAE;;AAE5D;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA,kCAAmB,mBAAmB,EAAE;AACxC,6CAA8B,gBAAgB,EAAE;AAChD,uCAAwB,cAAc,EAAE,iBAAiB,CAAC;;AAE1D;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,wBAAwB;IACxB,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA,0FAA8B,gBAAgB,EAAE,WAAW,CAAC;AAC5D,gDAAkB,YAAY,EAAE,mBAAmB,CAAC;;AAEpD,SAAS;AACT;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;;;AAIA,UAAU;AACV;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["@charset \"utf-8\";\n\n.settings {display: -webkit-box;display: -ms-flexbox;display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; width:100%;}\n.settings > div:nth-child(2n-1){width: 550px;}\n.settings > div:nth-child(2n){width: calc(100% - 610px);}\n.settings .container{\n    background: #fff;\n    padding: 15px;\n    border-radius: 10px;\n    -webkit-box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.10);\n            box-shadow: 4px 4px 15px 0px rgba(0, 0, 0, 0.10);\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n\n.settings .container#first {\n    flex:1;\n}\n\n.settings > .container:last-child  {\n    margin-bottom:20px;\n}\n\n.settings > div:nth-child(2) .container:nth-child(2) {\n    margin-top: 20px;\n}\n\n.settings > div .top{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center; margin-bottom: 10px;}\n.settings > div .top .more{ margin-left: auto; text-decoration: underline; font-weight:700; }\n.settings > div .top .more .on{ margin-left: auto; text-decoration: underline; font-weight:700; color:#51D7DF;}\n.settings > div .top .tit{\n    font-size: 18px;\n    font-weight: 700;\n}\n\n\n\n/*병원정보*/\n.h_info .basic{display: -webkit-box;display: -ms-flexbox;display: flex;}\n.h_info svg{position: relative; top: 2px; margin-right:5px;}\n.h_info .label{font-weight: 600; font-size:14px; color:#9D9D9D;}\n.h_info .basic .profile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-right:15px;\n}\n\n.h_info .basic .profile img {\n    width: 138px;\n    height: 138px;\n    border-radius: 15px;\n    margin: 0 22px;\n    margin-bottom: 10px;\n}\n\n.h_info .basic .profile .profileBtn {\n    display:flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.h_info .basic .profile button {\n    width: 80px;\n    height: 30px;\n    background: #51D7DF;\n    color: #FFFFFF;\n    border-radius: 5px;\n    border: none;\n    margin: 0px 5px;\n}\n\n.h_info .basic .profile input[type=\"file\"] { display: none; }\n\n.basic_con .data {\n    font-size:18px;\n    font-weight: 700;\n}\n.basic_con .tag_con {\n    flex-wrap: wrap;\n    width: 320px;\n    height: 65px;\n    overflow-y: scroll;\n    display:flex;\n    flex-direction: row;\n}\n\n.basic_con > div { margin-bottom: 12px; }\n.basic_con > div:last-child { margin-bottom: 0; }\n.basic_con > div span { display: block; margin-bottom:5px;}\n\n.basic_input {\n    background-color: white; \n    border: 1px solid #ccc; \n    border-radius: 5px; \n    padding: 5px 10px; \n    margin: 5px 0; \n    width: calc(100% - 20px); \n}\n\n.basic_textarea {\n    background-color: white;\n    border: 1px solid #ccc; \n    border-radius: 5px; \n    padding: 5px 10px; \n    margin: 5px 0; \n    width: calc(100% - 20px); \n    resize: none;\n    font-size:14px;\n    height: 60px;\n}\n\n.h_info .intro, .h_info .time{margin-top: 20px; height:80px;}\n.h_info .info_con{height: 80px; margin-bottom: 10px;}\n\n/* 후기확인 */\n.show_review .rv_password {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap:10px;\n}\n\n.show_review .rv_password > p {\n    display: flex;\n    width:120px;\n    height:30px;\n    align-items: center; \n    color: #8B8686;\n}\n\n.show_review .rv_password input {\n    width: auto;\n    height: 30px;\n    border: 1px solid #ccc;\n    font-size:14px;\n    border-radius: 5px;\n    padding: 5px 10px;\n    margin: 5px 0;\n}\n\n.show_review .rv_password button {\n    width: 100px;\n    height: 30px;\n    background: #51D7DF;\n    color: #FFFFFF;\n    border-radius: 5px;\n    border: none;\n}\n\n\n\n/* 예약 연동 */\n.rsv_conn .channel {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    text-align: center;\n    gap:10px;\n}\n\n.channel .tit {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap:3px; \n}\n\n.channel .tit > img {\n    width:18px;\n    height:18px;\n}\n\n.channel .tit > p {\n    display: flex;\n    width:90px;\n    height:30px;\n    align-items: center; \n    color: #000;\n    font-weight: 400;\n}\n\n.channel input[type=\"text\"] {\n    width: auto;\n    height: 30px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 5px 10px;\n}\n.channel .toggle {\n    display:flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap:10px;\n    width: 120px;\n    height: 50px;\n    font-size: 14px;\n}\n.toggle p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.toggle .use {\n    color:#34C759;\n}\n\n.toggle .notuse {\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings": `Setting_settings__HTr7K`,
	"container": `Setting_container__qQa36`,
	"first": `Setting_first__XjWsb`,
	"top": `Setting_top__ad0Sk`,
	"more": `Setting_more__OBn7y`,
	"on": `Setting_on__pnNQV`,
	"tit": `Setting_tit__bzvYY`,
	"h_info": `Setting_h_info__rA0zx`,
	"basic": `Setting_basic__Rpr0x`,
	"label": `Setting_label__P51JP`,
	"profile": `Setting_profile__68kX+`,
	"profileBtn": `Setting_profileBtn__Al5ut`,
	"basic_con": `Setting_basic_con__gLTu1`,
	"data": `Setting_data__W5Wi6`,
	"tag_con": `Setting_tag_con__k12Bd`,
	"basic_input": `Setting_basic_input__cbNeN`,
	"basic_textarea": `Setting_basic_textarea__50FQC`,
	"intro": `Setting_intro__SV20G`,
	"time": `Setting_time__rbxaq`,
	"info_con": `Setting_info_con__GZqzE`,
	"show_review": `Setting_show_review__z0ZeC`,
	"rv_password": `Setting_rv_password__uAXOm`,
	"rsv_conn": `Setting_rsv_conn__XxCSZ`,
	"channel": `Setting_channel__atLS7`,
	"toggle": `Setting_toggle__vX+mt`,
	"use": `Setting_use__VK-WY`,
	"notuse": `Setting_notuse__LhN1r`
};
export default ___CSS_LOADER_EXPORT___;
